/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { type ChangeEvent, useState } from 'react';
import { Eye, EyeOff } from 'styled-icons/remix-line';

import colors from '../../../styles/colors';

import {
  InputStyled,
  InputContainer,
  InputLabel,
  HidePasswordAction,
  HidePasswordContainer,
} from './styles';

interface IInputFormik {
  placeholder?: string;
  name?: string;
  type?: string;
  error?: any;
  touched?: any;
  value?: any;
  component?: React.ComponentType<any>;
  options?: any;
  defaultValue?: any;
  mask?: string;
  isErrorMessage?: any;
  formatChars?: any;
  beforeMaskedValueChange?: any;
  onChange?: (e: ChangeEvent<any>) => void;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const InputPassword: React.FC<IInputFormik> = ({
  placeholder,
  name,
  error,
  touched,
  value,
  component,
  options,
  defaultValue,
  mask,
  formatChars,
  beforeMaskedValueChange,
  isErrorMessage,
  children,
  onChange,
  onClick,
}: IInputFormik) => {
  const [passwordInputType, setPasswordInputType] = useState<boolean>(true);
  const [type, setType] = useState<string>('password');
  const isWarning = !!error && touched;

  const isDanger = value && value.length > 0 && isWarning;
  const isSuccess =
    !isWarning && !isDanger && value && (value.length > 0 || value !== null);

  function showHidePassword(): void {
    setPasswordInputType(!passwordInputType);

    if (!passwordInputType) {
      setType('password');
    } else {
      setType('text');
    }
  }

  return (
    <InputContainer
      data-success={isSuccess}
      data-warning={isWarning}
      data-danger={isDanger}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        {(isWarning || isDanger || isSuccess) && (
          <InputLabel htmlFor={name}>{placeholder}</InputLabel>
        )}
        <InputStyled
          id={name}
          name={name}
          placeholder={placeholder}
          type={type}
          component={component}
          options={options}
          defaultValue={defaultValue}
          mask={mask}
          formatChars={formatChars}
          beforeMaskedValueChange={beforeMaskedValueChange}
          onChange={onChange}
          onClick={onClick}
        />
        {!!value && (
          <>
            <HidePasswordContainer
              style={{ marginTop: value || error ? 4 : 0 }}
            >
              <HidePasswordAction onClick={showHidePassword}>
                {passwordInputType ? (
                  <EyeOff size={18} color="#a6a7aa" />
                ) : (
                  <Eye size={18} color={colors.blueEinstein} />
                )}
              </HidePasswordAction>
            </HidePasswordContainer>
          </>
        )}
      </div>

      {children}
    </InputContainer>
  );
};
